import { useNotificationsCountQuery } from '../../services/notifcationsApi'

export const useNotificationsCount = () => {
  const { data, isFetching } = useNotificationsCountQuery(undefined, {
    pollingInterval: 5000,
  })

  return {
    unviewedNotifications: data?.result.unseen_notifications ?? null,
    viewedNotifications: data?.result.seen_notifications ?? null,
    isNotificationsCountFetching: isFetching,
  }
}
